import { useEffect, useState } from "react";
import { fetchCatalog } from "../api/catalog";
import ProductCard from "./ProductCard";
import { storePath as storefrontPath } from "../lib/storePaths";

function storePath(storeSlug, suffix = "") {
  return storefrontPath(suffix, storeSlug);
}

export default function LatestProducts({
  block,
  storeSlug,
  preview = false,
  fallbackProducts = [],
  className = "",
}) {
  const limit = Math.min(Math.max(Number(block.limit) || 6, 1), 24);
  const category = block.category || "";
  const tag = block.tag || "";
  const needsOwnFetch = Boolean(category || tag || limit > fallbackProducts.length);
  const [products, setProducts] = useState(needsOwnFetch ? [] : fallbackProducts.slice(0, limit));
  const [loaded, setLoaded] = useState(!needsOwnFetch);

  useEffect(() => {
    if (!needsOwnFetch) {
      setProducts(fallbackProducts.slice(0, limit));
      setLoaded(true);
      return undefined;
    }
    const controller = new AbortController();
    setLoaded(false);
    fetchCatalog(storeSlug, {
      page: 1,
      limit,
      preview,
      filters: {
        ...(category ? { category } : {}),
        ...(tag ? { tag } : {}),
      },
      signal: controller.signal,
    })
      .then((result) => {
        setProducts((result?.products || []).slice(0, limit));
        setLoaded(true);
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        setProducts([]);
        setLoaded(true);
      });
    return () => controller.abort();
  }, [category, fallbackProducts, limit, needsOwnFetch, preview, storeSlug, tag]);

  return (
    <div className={`${className} home-products`}>
      <div className="home-products__heading">
        {block.title ? <h2>{block.title}</h2> : null}
        <a href={storePath(storeSlug, "/products")}>Ver todos</a>
      </div>
      {products.length > 0 ? (
        <div className="product-grid">
          {products.map((product) => (
            <ProductCard product={product} storeSlug={storeSlug} key={product.id} />
          ))}
        </div>
      ) : loaded ? (
        <p className="home-products__empty">Esta loja ainda não publicou produtos.</p>
      ) : null}
    </div>
  );
}
